import { c as _c } from "react/compiler-runtime";
import { ActionMenuItemProps } from '@systemeio/ui';
import StudentProgressExportNotificationItem from 'modules/courses/students/components/student-progress-export-notification-item';
import SharingNotificationItem from 'modules/share/components/sharing-notification-item';
import { NotificationTypeEnum } from 'modules/profile/notification-settings/enums/notification-settings-enum';
import useUser from 'shared/hooks/use-user';
import { openWindowSafely } from '@systemeio/util';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { getNotificationIcon } from '../constants/notification-icons';
import { useNotificationsActions } from '../hooks/use-notification-actions';
import { NotificationBaseItemInterface } from '../types/base-notification-interface';
import { NotificationItemInterface } from '../types/notification-types';
import { NotificationItemView } from './notification-item-view';
export interface BaseNotificationProps {
  notification: NotificationBaseItemInterface;
  actions?: ActionMenuItemProps[];
}
const BaseNotificationItem = t0 => {
  const $ = _c(14);
  const {
    notification
  } = t0;
  const {
    user
  } = useUser();
  const {
    getNotificationLink
  } = useNotificationsActions();
  let t1;
  if ($[0] !== getNotificationLink || $[1] !== notification.id) {
    t1 = async () => {
      const safeWindow = openWindowSafely();
      ;
      try {
        const {
          link
        } = await getNotificationLink(notification.id);
        safeWindow.navigate(link);
      } catch (t2) {
        const error = t2;
        safeWindow.close();
        throw error;
      }
    };
    $[0] = getNotificationLink;
    $[1] = notification.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleNotificationClick = t1;
  const t2 = notification.read;
  let t3;
  if ($[3] !== notification) {
    t3 = getNotificationIcon(notification);
    $[3] = notification;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== notification.createdAt || $[6] !== user) {
    t4 = user && <div className="group-hover:text-text-primary transition">{dateTimeFormat(notification.createdAt, {
        timeFormat: user.timeFormat,
        dateFormat: user.dateFormat,
        timeZone: user.timezone
      })}</div>;
    $[5] = notification.createdAt;
    $[6] = user;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== handleNotificationClick || $[9] !== notification.message || $[10] !== notification.read || $[11] !== t3 || $[12] !== t4) {
    t5 = <NotificationItemView isRead={t2} icon={t3} message={notification.message} description={t4} onClick={handleNotificationClick} />;
    $[8] = handleNotificationClick;
    $[9] = notification.message;
    $[10] = notification.read;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export interface NotificationItemProps {
  notification: NotificationItemInterface;
  actions?: ActionMenuItemProps[];
}
export const NotificationItem = t0 => {
  const $ = _c(7);
  const {
    notification,
    actions
  } = t0;
  switch (notification.eventType) {
    case NotificationTypeEnum.StudentProgressExport:
      {
        let t1;
        if ($[0] !== notification) {
          t1 = <StudentProgressExportNotificationItem notification={notification} />;
          $[0] = notification;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case NotificationTypeEnum.SharingStarted:
      {
        let t1;
        if ($[2] !== notification) {
          t1 = <SharingNotificationItem notification={notification} />;
          $[2] = notification;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    default:
      {
        let t1;
        if ($[4] !== actions || $[5] !== notification) {
          t1 = <BaseNotificationItem notification={notification} actions={actions} />;
          $[4] = actions;
          $[5] = notification;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
  }
};